import { ARCGIS_CONSTANTS } from '../constants/arcgis-constants';
import { ArcGISDrawingInfo, ArcGISFeatureServiceItemData, ArcGISLayerDefinition } from '../models/arcgis-types';
import { normalizeArcGISRenderer } from './arcgis-renderer.util';

export function resolveArcGISItemPortal(serviceUrl: string, tokenUrl?: string | null): string | null {
    try {
        if (tokenUrl) {
            const issuer = new URL(tokenUrl);
            const path = issuer.pathname.replace(/\/sharing\/(?:rest\/)?generateToken\/?$/i, '');
            if (issuer.protocol === 'https:' && !issuer.username && !issuer.password &&
                !issuer.search && !issuer.hash && path !== issuer.pathname) {
                return issuer.origin + path;
            }
            return null;
        }

        const service = new URL(serviceUrl);
        if (service.protocol === 'https:' && /^services\d*\.arcgis\.com$/i.test(service.hostname)) {
            return ARCGIS_CONSTANTS.DEFAULT_PORTAL_URL;
        }
    } catch {
        return null;
    }
    return null;
}

export function resolveArcGISItemLayerDefinition(
    serviceDefinition: ArcGISLayerDefinition,
    itemData: ArcGISFeatureServiceItemData | null,
    layerId: number | string,
): ArcGISLayerDefinition {
    const override = itemData?.layers?.find(layer => String(layer.id) === String(layerId))?.layerDefinition;
    return {
        drawingInfo: resolveArcGISItemDrawingInfo(serviceDefinition.drawingInfo, itemData, layerId) ?? undefined,
        minScale: override?.minScale ?? serviceDefinition.minScale,
        maxScale: override?.maxScale ?? serviceDefinition.maxScale
    };
}

export function resolveArcGISItemDrawingInfo(
    serviceDrawingInfo: ArcGISDrawingInfo | null | undefined,
    itemData: ArcGISFeatureServiceItemData | null,
    layerId: number | string,
): ArcGISDrawingInfo | null {
    const override = itemData?.layers?.find(layer => String(layer.id) === String(layerId))?.layerDefinition?.drawingInfo;
    const renderer = override?.renderer || serviceDrawingInfo?.renderer;
    return renderer ? { ...serviceDrawingInfo, ...override, renderer: normalizeArcGISRenderer(renderer) } : null;
}
